import { toast } from "sonner";

/**
 * Share links for saved proposals. The link is just the proposals route with
 * `?proposal=<id>` — anyone with `proposals.read` who opens it gets that
 * proposal loaded into the calculator (ProposalsPage's link-load flow).
 * Used from the calculator header and each Saved Proposals row.
 */
export const shareUrl = (proposalId: string): string =>
  `${window.location.origin}/proposals?proposal=${encodeURIComponent(proposalId)}`;

/** Selection-based copy for contexts where the async clipboard API is denied
 *  (strict permission policies, embedded webviews). */
function legacyCopy(text: string): boolean {
  const ta = document.createElement("textarea");
  ta.value = text;
  ta.setAttribute("readonly", "");
  ta.style.position = "fixed";
  ta.style.opacity = "0";
  document.body.appendChild(ta);
  ta.select();
  let ok = false;
  try {
    ok = document.execCommand("copy");
  } catch {
    ok = false;
  }
  document.body.removeChild(ta);
  return ok;
}

export async function copyShareLink(proposalId: string): Promise<void> {
  const url = shareUrl(proposalId);
  let ok = false;
  try {
    await navigator.clipboard.writeText(url);
    ok = true;
  } catch {
    ok = legacyCopy(url);
  }
  if (ok) toast.success("Link copied — anyone with proposals access can open it.");
  else toast.error("Couldn't copy — the browser blocked clipboard access.");
}
